import {
  createPlugin,
  createApiFactory,
  identityApiRef,
  discoveryApiRef,
  createRoutableExtension,
  createComponentExtension,
} from '@backstage/core-plugin-api';

import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { ScoringDataClient, scoringDataApiRef } from './api';
import { rootRouteRef } from './routes';

export const maturityPlugin = createPlugin({
  id: 'maturity',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: scoringDataApiRef,
      deps: {
        catalogApi: catalogApiRef,
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ catalogApi, discoveryApi, identityApi }) =>
        new ScoringDataClient({
          catalogApi,
          discoveryApi,
          identityApi,
        }),
    }),
  ],
});

export const MaturityScoreContent = maturityPlugin.provide(
  createRoutableExtension({
    name: 'MaturityScoreContent',
    component: () => import('./ScoreRouter').then(m => m.ScoreRouter),
    mountPoint: rootRouteRef,
  }),
);

export const MaturitySummaryContent = maturityPlugin.provide(
  createRoutableExtension({
    name: 'MaturitySummaryContent',
    component: () => import('./SummaryRouter').then(m => m.SummaryRouter),
    mountPoint: rootRouteRef,
  }),
);

export const MaturityRankWidget = maturityPlugin.provide(
  createComponentExtension({
    name: 'MaturityRankWidget',
    component: {
      lazy: () =>
        import('./components/widgets/MaturityRankWidget').then(
          m => m.MaturityRankWidget,
        ),
    },
  }),
);

export const MaturityPage = maturityPlugin.provide(
  createComponentExtension({
    name: 'MaturityPage',
    component: {
      lazy: () => import('./components/MaturityPage').then(m => m.MaturityPage),
    },
  }),
);

export const MaturityChecksTable = maturityPlugin.provide(
  createComponentExtension({
    name: 'MaturityChecksTable',
    component: {
      lazy: () =>
        import('./components/tables/MaturityChecksTable').then(
          m => m.MaturityChecksTable,
        ),
    },
  }),
);

export const MaturitySummaryInfoCard = maturityPlugin.provide(
  createComponentExtension({
    name: 'MaturitySummaryInfoCard',
    component: {
      lazy: () =>
        import('./components/cards/MaturitySummaryInfoCard').then(
          m => m.MaturitySummaryInfoCard,
        ),
    },
  }),
);

export const MaturityRankAvatar = maturityPlugin.provide(
  createComponentExtension({
    name: 'MaturityRankAvatar',
    component: {
      lazy: () =>
        import('./components/widgets/MaturityRankAvatar').then(
          m => m.MaturityRankAvatar,
        ),
    },
  }),
);

export const MaturityBreakdownTable = maturityPlugin.provide(
  createComponentExtension({
    name: 'MaturityBreakdownTable',
    component: {
      lazy: () =>
        import('./components/tables/MaturityBreakdownTable').then(
          m => m.MaturityBreakdownTable,
        ),
    },
  }),
);
